<template>
  <table class="table-component" cellspacing="0">
    <thead>
      <tr>
        <th
          v-for="key in columns"
          @click="sortBy(key)"
          :class="{ active: sortKey == key }"
        >
          {{ key | capitalize }}
          <span
            class="arrow"
            :class="sortOrders[key] > 0 ? 'asc' : 'dsc'"
          ></span>
        </th>
        <th v-if="Object.keys(actions).length > 0">&nbsp;</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="entry in filteredItems">
        <td v-for="key in columns">{{ entry[key] }}</td>
        <td>
          <router-link v-for="(urlKey, action) in actions" :to="entry[urlKey]">
            {{ action }}
          </router-link>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  name: "Table",
  props: {
    items: Array,
    columns: Array,
    filterKey: {
      type: String,
      default: "",
    },
    filterField: {
      type: Object,
      default: function () {
        return {};
      },
    },
    actions: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data: function () {
    var sortOrders = {};
    this.columns.forEach(function (key) {
      sortOrders[key] = 1;
    });
    return {
      sortKey: "",
      sortOrders: sortOrders,
    };
  },
  computed: {
    filteredItems: function () {
      var sortKey = this.sortKey;
      var filterKey = this.filterKey && this.filterKey.toLowerCase();
      var order = this.sortOrders[sortKey] || 1;
      var items = this.items;
      if (filterKey) {
        items = items.filter(function (row) {
          return Object.keys(row).some(function (key) {
            return String(row[key]).toLowerCase().indexOf(filterKey) > -1;
          });
        });
      }
      if (
        Object.keys(this.filterField).includes("key") &&
        Object.keys(this.filterField).includes("value")
      ) {
        items = items.filter((row) => {
          return row[this.filterField.key] === this.filterField.value;
        });
      }
      if (sortKey) {
        items = items.slice().sort(function (a, b) {
          a = a[sortKey];
          b = b[sortKey];
          return (a === b ? 0 : a > b ? 1 : -1) * order;
        });
      }
      return items;
    },
  },
  filters: {
    capitalize: function (str) {
      return str.charAt(0).toUpperCase() + str.slice(1);
    },
  },
  methods: {
    sortBy: function (key) {
      this.sortKey = key;
      this.sortOrders[key] = this.sortOrders[key] * -1;
    },
  },
};
</script>

<style lang="scss">
.table-component {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0 1em;
  thead {
    font-weight: bold;
  }
  tr {
    outline: solid 1px black;
    th,
    td {
      padding: 0.8em;
    }
  }
  .arrow {
    display: inline-block;
    width: 0;
    height: 0;
    margin-bottom: 1px;
    margin-left: 5px;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-top: none;
    border-bottom: 5px solid #999;
  }
  .arrow.dsc {
    border-top: 5px solid #999;
    border-bottom: none;
  }
  th.active .arrow {
    border-top: none;
    border-bottom: 5px solid black;
  }
  th.active .arrow.dsc {
    border-top: 5px solid black;
    border-bottom: none;
  }
}
</style>



// WEBPACK FOOTER //
// Table.vue?69b8062a